import { faAdd } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormikProps } from 'formik';
import * as React from 'react';
import VoxelIconButton from '../../../../../../../../../voxel/Buttons/VoxelIconButton';
import { useAddGroup } from '../../logic/stateActions/addGroup';
import { ComboFormState, FormWordGroup } from '../../models/ComboFormState';
import { SetFormState } from '../../models/SetFormState';
import WordGroupListItem from './WordGroupListItem';

export interface WordGroupListProps {
  wordGroups: FormWordGroup[];
  formState: FormikProps<ComboFormState>;
  setFormState: SetFormState;
  disabled: boolean;
}

const WordGroupList: React.FC<WordGroupListProps> = React.memo(
  ({ wordGroups, setFormState, disabled, formState }) => {
    const handleAddGroup = useAddGroup(setFormState);

    return (
      <>
        <div className="flex flex-row gap-8 max-w-screen-xl overflow-auto">
          {wordGroups.map((wordGroup, index) => (
            <WordGroupListItem
              key={wordGroup.id}
              wordGroup={wordGroup}
              setFormState={setFormState}
              disabled={disabled}
              index={index}
            />
          ))}

          <div className="pt-5">
            <VoxelIconButton
              icon={<FontAwesomeIcon icon={faAdd} size="lg" />}
              onClick={handleAddGroup}
              color={'blue'}
              size="lg"
              disabled={disabled}
            />
          </div>
        </div>
      </>
    );
  }
);

export default WordGroupList;
